/**
 * The consultation type enum
 */
export enum ConsultationType {
  /** the first visit */
  FIRST_VISIT = "first_visit",

  /** booking by prescription */
  PRESCRIPTION = "prescription",

  /** booking by voluntary */
  VOLUNTARY = "voluntary",

  /** changes the booking program */
  REPROGRAMMING = "reprogramming",
}
